import React from 'react';

import { MergeCells } from '@components/shared/Tiptap/icons';
import { Tooltip } from '@components/Tooltip';

export const MergedCategoryIcon = ({
  mergedCategories,
  defaultCategories,
  category
}: {
  mergedCategories: { name: string; categories: string[] }[];
  category: string;
  defaultCategories: string[];
}) => {
  const mergedCategory = mergedCategories.find((merged) => merged.name === category);
  if (!mergedCategory?.categories.length) return null;

  let tooltip: string = '';

  if (mergedCategory.categories.length === 1) {
    const firstCategoryLabel = `${mergedCategory.categories[0]} ${defaultCategories.includes(mergedCategory.categories[0]) ? '(Closed)' : '(Open)'}`;
    tooltip = `Merged using ${firstCategoryLabel}`;
  } else if (mergedCategory.categories.length === 2) {
    const firstCategoryLabel = `${mergedCategory.categories[0]} ${defaultCategories.includes(mergedCategory.categories[0]) ? '(Closed)' : '(Open)'}`;
    const secondCategoryLabel = `${mergedCategory.categories[1]} ${defaultCategories.includes(mergedCategory.categories[1]) ? '(Closed)' : '(Open)'}`;
    tooltip = `Merged using ${firstCategoryLabel} and ${secondCategoryLabel}`;
  } else {
    const categories = mergedCategory.categories.map(
      (category) => `${category} ${defaultCategories.includes(category) ? '(Closed)' : '(Open)'}`
    );

    const lastElement = categories.pop() as string;

    tooltip = `Merged using ${categories.join(', ')}, and ${lastElement}`;
  }

  return (
    <Tooltip maxWidth={200} content={tooltip}>
      <span className='ml-2'>
        <MergeCells className='text-green-600' />
      </span>
    </Tooltip>
  );
};
